/* istanbul ignore file */
import React from 'react'
import { ReduxFormFieldWrapper } from '@adc/ui-core'
import RichTextField, { TemplatingRichTextField } from '../richTextFieldNoRedux'
import '../../../scss/global.scss'

// CORE version - redux wrapped
const RichTextFieldReduxFormWrapper = ReduxFormFieldWrapper(fieldProps => (
  <RichTextField {...fieldProps} />
))

const TemplatingRichTextFieldReduxFormWrapper = ReduxFormFieldWrapper(
  fieldProps => <TemplatingRichTextField {...fieldProps} />
)

// MORPHEUS version (compacted)
const RichTextFieldRedux = fieldProps => (
  <RichTextFieldReduxFormWrapper
    compact
    {...fieldProps}
    componentName='RichTextField'
  />
)

const TemplatingRichTextFieldRedux = fieldProps => (
  <TemplatingRichTextFieldReduxFormWrapper compact {...fieldProps} />
)

export default RichTextFieldRedux
export { TemplatingRichTextFieldRedux as TemplatingRichTextField }
